export const OPEN_MODAL = 'header/modals/OPEN_MODAL';

export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';

export const CLOSE_CREATE_ACCOUNT = 'CLOSE_CREATE_ACCOUNT';

export const CLOSE_CURRENT_MODAL = 'header/modals/CLOSE_CURRENT_MODAL';

export const HANDLE_PROMOTIONS = 'header/modals/HANDLE_PROMOTIONS';
